var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.25C0 1.45742 1.44497 0 3.22222 0H11.2778V6.5C11.2778 7.39883 11.9977 8.125 12.8889 8.125H19.3333V10.0852C15.6127 11.1465 12.8889 14.5945 12.8889 18.6875C12.8889 21.6887 14.354 24.3395 16.5995 25.9645C16.4384 25.9898 16.2773 26 16.1111 26H3.22222C1.44497 26 0 24.5426 0 22.75V3.25ZM19.3333 6.5H12.8889V0L19.3333 6.5ZM14.5 18.6875C14.5 16.7481 15.2638 14.8881 16.6235 13.5168C17.9831 12.1454 19.8272 11.375 21.75 11.375C23.6728 11.375 25.5169 12.1454 26.8765 13.5168C28.2362 14.8881 29 16.7481 29 18.6875C29 20.6269 28.2362 22.4869 26.8765 23.8582C25.5169 25.2296 23.6728 26 21.75 26C19.8272 26 17.9831 25.2296 16.6235 23.8582C15.2638 22.4869 14.5 20.6269 14.5 18.6875ZM25.1384 16.4887C24.8262 16.1738 24.3127 16.1738 24.0005 16.4887L20.9444 19.5711L19.4995 18.1137C19.1873 17.7988 18.6738 17.7988 18.3616 18.1137C18.0495 18.4285 18.0495 18.9465 18.3616 19.2613L20.3755 21.2926C20.6877 21.6074 21.2012 21.6074 21.5134 21.2926L25.1384 17.6363C25.4505 17.3215 25.4505 16.8035 25.1384 16.4887Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilecheck);
export default __webpack_public_path__ + "static/media/filecheck.07cf7282bb8dea2f2252ccea451b233d.svg";
export { ForwardRef as ReactComponent };